import { WsCalls } from '@/store/services/wsCalls';

// initial state
const state = () => ({
  request: {
    cupons: [],
    wallet_value: 0,
    shipping_fee: 0,
    total_descontos: 0,
    total_final: 0
  },
  orders: [],
  lastorder: 0,
  loadingOrders: true,
  loadingOrder: true
})
  
// getters
const getters = {
  getCupons: (state) => {
    return state.request.cupons;
  },
  getWalletValue: (state) => {
    return state.request.wallet_value;
  },
  getTotalFinal: (state) => {
    return state.request.total_final;
  },
  getOrderRequest: (state) => {
    return state.request;
  },
  getOrders: (state) => {
    return state.orders;
  },
  getLastorder: (state) => {
    return state.lastorder;
  },
}
  
// actions
const actions = {
  async addCupom ({ commit, dispatch }, cupom) {
    commit('addCupom', cupom);
    dispatch('updateTotalFinal');
  },
  async removeCupom ({ commit, dispatch }, cupom) {
    commit('removeCupom', cupom);
    dispatch('updateTotalFinal');
  },
  async getWalletValue({ commit, dispatch, rootGetters }){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'wallet', rootGetters['main/getConfig'], null).then(function (response) {
        commit('setWalletValue', response.data.return.balance);
        dispatch('updateTotalFinal');
        resolve(true);
      });
    });
  },
  async setWalletValue ({ commit, dispatch, rootGetters }, valor) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'wallet', rootGetters['main/getConfig'], {"value": valor}).then(function (response) {
        commit('setWalletValue', valor);
        dispatch('updateTotalFinal');
        resolve(true);
      });
    });
  },
  async updateFrete ({ commit, dispatch, rootGetters }, parametros){
    let frete = 0;
    if(parametros.address.area != null) {
      frete = parametros.express == 1 ? parametros.address.area.express.shipping : parametros.address.area.shipping;
    }
    if(rootGetters['cupons/freteGratis']){
      frete = 0;
    }
    commit('setFrete', frete);
    dispatch('updateTotalFinal');
  },
  async updateDesconto ({ commit, dispatch }, desconto){
    commit('setDesconto', desconto);
    dispatch('updateTotalFinal');
  },
  async updateTotalFinal ({ commit, rootGetters }){
    commit('updateTotalFinal', parseFloat(rootGetters['cart/getTotalValueCart']));
  },
  async preOrder({ commit, dispatch, rootGetters }){
    return new Promise((resolve) => {
      dispatch('cart/sendCart', null, { root: true }).then(function(){
        WsCalls.callMethodWS('POST', 'preOrder', rootGetters['main/getConfig']).then(function (response) {
          if(response.data.return != null){
            commit('cart/setModifiedShoppingCart', response.data.return.modified_shopping_cart, { root: true });
          }
          resolve(true);
        });
      });
    });
  },
  async finalizeOrder({ commit, rootGetters }, parametros){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'finalizeOrder', rootGetters['main/getConfig'], parametros).then(function (response) {
        if(response.data.cod == 200 || response.data.cod == 201){
          commit("setLastorder", response.data.return.order_id);
          commit("setWalletValue", 0);
        }
        resolve(response.data);
      });
    });
  },
  async loadOrders ({ commit, rootGetters }, parametros) {
    if(parametros == "0")
      commit('setLoadingOrders', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'orders', rootGetters['main/getConfig'], parametros).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          if(parametros == "0"){
            commit('setOrders', response.data.return);
          } else {
            commit('concatOrders', response.data.return);
          }
          commit('setLoadingOrders', false);
          resolve(true);
        } else {
          if(parametros == "0"){
            commit('setOrders', []);
          }
          commit('setLoadingOrders', false);
          resolve(false);
        }
      });
    });
  },
  async getOrderDetails ({ commit, rootGetters }, parametros) {
    commit('setLoadingOrder', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'order', rootGetters['main/getConfig'], parametros).then(function (response) {
        commit('setLoadingOrder', false);
        resolve(response.data);
      });
    });
  },
  async getPix({ rootGetters }, parametros){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'pix', rootGetters['main/getConfig'], parametros).then(function (response) {
        if(response.data.cod == 100){
          response.data.return.qr_code_base64 = `data:image/png;base64,${response.data.return.qr_code_base64}`;
          resolve(response.data.return);
        } else {
          resolve(null);
        }
      });
    });
  },
  async setNps({ rootGetters }, parametros){

    let endpoint = "npsStore";
    if(parametros.order_id != undefined && parametros.is_physical_nps == 0){
      endpoint = "npsEcommerce";
    }
    if(parametros.order_id != undefined && parametros.is_physical_nps == 1){
      endpoint = "npsPhysical";
    }

    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', endpoint, rootGetters['main/getConfig'], parametros).then(function (response) {
        resolve(response.data);
      });
    });
  },
  async orderRepeat({ rootGetters, dispatch }, parametros){
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'orderRepeat', rootGetters['main/getConfig'], { "order_id": parametros }).then(function (response) {
        dispatch("cart/loadItensCart", null, { root: true });
        resolve(response.data);
      });
    });
  },
  async cancelOrder({ rootGetters }, orderId) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'cancelOrder', rootGetters['main/getConfig'], { "order_id": orderId })
      .then(response => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Erro ao chamar cancelOrder:", error);
        resolve({ cod: 402, msg: 'Erro ao cancelar o pedido.' });
      });
    });
  }
}

// mutations
const mutations = {
  addCupom (state, cupom) {
    state.request.cupons.push(cupom);
  },
  removeCupom (state, cupom) {
    state.request.cupons = state.cupons.filter(function(a){ a != cupom });
  },
  setWalletValue (state, valor) {
    state.request.wallet_value = valor;
  },
  setFrete (state, valor) {
    state.request.shipping_fee = valor;
  },
  setDesconto (state, valor) {
    state.request.total_descontos = valor;
  },
  updateTotalFinal (state, total_carrinho) {
    let total = total_carrinho + state.request.shipping_fee - state.request.total_descontos - state.request.wallet_value;
    state.request.total_final = total > 0 ? total: 0;
  },
  setOrders (state, orders) {
    state.orders = orders;
  },
  concatOrders (state, orders) {
    state.orders = state.orders.concat(orders);
  },
  setLastorder (state, lastorder) {
    state.lastorder = lastorder;
  },
  setLoadingOrders (state, status) {
    state.loadingOrders = status;
  },
  setLoadingOrder (state, status) {
    state.loadingOrder = status;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}